import { render, staticRenderFns } from "./exchange-code.vue?vue&type=template&id=73e467b3&scoped=true&"
import script from "./exchange-code.vue?vue&type=script&lang=js&"
export * from "./exchange-code.vue?vue&type=script&lang=js&"
import style0 from "./exchange-code.scss?vue&type=style&index=0&id=73e467b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e467b3",
  null
  
)

export default component.exports